import { ChevronDown, PackageCheck } from "lucide-react";
import { garments } from "../data/garments";
import { getOrderTotal } from "../lib/orders";
import type { GarmentOrder } from "../types";

type OrderGroupProps = {
  name: string;
  orders: GarmentOrder[];
  selectable?: boolean;
  selected?: boolean;
  onSelectedChange?: (selected: boolean) => void;
};

const dateFormatter = new Intl.DateTimeFormat("sv-SE", {
  year: "numeric",
  month: "short",
  day: "numeric",
});

export function OrderGroup({ name, orders, selectable, selected, onSelectedChange }: OrderGroupProps) {
  const supplierName = garments.find((garment) => garment.name === name)?.supplierName;

  return (
    <details className="order-group">
      <summary>
        {selectable && (
          <span className="order-group__checkbox" onClick={(event) => event.stopPropagation()}>
            <input
              type="checkbox"
              checked={selected}
              onChange={(event) => onSelectedChange?.(event.target.checked)}
              aria-label={`Välj ${name}`}
            />
          </span>
        )}
        <span className="order-group__icon"><PackageCheck size={20} /></span>
        <span className="order-group__title">
          <strong>{name}</strong>
          {supplierName && <small>{supplierName}</small>}
        </span>
        <span className="order-group__count">{getOrderTotal(orders)} st</span>
        <ChevronDown className="order-group__chevron" size={20} />
      </summary>
      <div className="order-group__content">
        {orders.map((order, index) => {
          const email = order.email ?? order.mail;

          return (
            <div className="person-order" key={`${order.date}-${order.name}-${index}`}>
              <div>
                <strong>{order.name}</strong>
                {email && <a href={`mailto:${email}`}>{email}</a>}
                {order.phone && (
                  <a href={`tel:${order.phone.replace(/[^\d+]/g, "")}`}>{order.phone}</a>
                )}
                <span>{dateFormatter.format(order.date)}</span>
              </div>
              <p>
                {Object.entries(order.sizes).map(([size, count]) => (
                  <span key={size}><strong>{count}</strong> × {size}</span>
                ))}
              </p>
            </div>
          );
        })}
      </div>
    </details>
  );
}
